export default __webpack_public_path__ + "static/media/support-label.c9781d8c.yaml";